import React from "react";
import HtmlTooltip from "../HtmlTooltilp";
import { Typography } from "@mui/material";
import { InfoOutlined } from "@mui/icons-material";

type FieldProps = {
    title: string,
    content: string
}

export const FieldTooltip = ( props: FieldProps ) => (
    <HtmlTooltip
      title={
        <React.Fragment>
          <Typography color="inherit">{props.title}</Typography>
          {props.content}

        </React.Fragment>
      }
    >
      <InfoOutlined className='text-gray-text ml-2 text-contrast-50' fontSize="small" style={{

      }} />
    </HtmlTooltip>
  )